module.exports = __webpack_public_path__ + "static/Hastee-47bb90caf436f06ef60c92b3ea428818.jpg";